export const DEBUG = false; // Cambia a false para funcionamiento normal
export const $debug = DEBUG;

// get enviroment from .env file
export const enviroment = process.env.NODE_ENV;

export const baseurl =
	enviroment === "development"
		? process.env.REACT_APP_SERVER
		: process.env.REACT_APP_SERVER;

export const warningHeader = enviroment === "development" ? "Desarrollo" : "";

export const permisos_comerciales = [
	{ key: "permiso_20", label: "Altas", },
	{ key: "permiso_33", label: "Gestión de créditos activos", },
	{ key: "permiso_17", label: "Reporte de colocación", },
	{ key: "permiso_15", label: "Listado de trabajadores", },
	{ key: "permiso_3", label: "Reportes", },
];

export const permisos_cartera = [
	{ key: "permiso_21", label: "Bajas", },
	{ key: "permiso_16", label: "Análisis de cobranza", },
	{ key: "permiso_30", label: "Estados de cuenta", },
	{ key: "permiso_34", label: "Administración de créditos activos", },
	{ key: "permiso_3", label: "Reportes", },
	{ key: "permiso_35", label: "Proyecciones", },
];

export const permisos_administracion = [
	{ key: "permiso_16", label: "Análisis de cobranza", },
	{ key: "permiso_17", label: "Reporte de colocación", },
	{ key: "permiso_3", label: "Reportes", },
	{ key: "permiso_35", label: "Proyecciones", },
];

export const EXCEPCIONES_PERMISOS = [
	{
		clave_organizacion: "C982",
		permisos_no_permitidos: ["permiso_20", "permiso_33", "permiso_17", "permiso_15"],
	},
	{
		clave_organizacion: "182",
		permisos_no_permitidos: ["permiso_20", "permiso_33", "permiso_17", "permiso_15"],
	},
	{
		clave_organizacion: "C985",
		permisos_no_permitidos: ["permiso_20", "permiso_33", "permiso_17", "permiso_15"],
	},
	{
		clave_organizacion: "185",
		permisos_no_permitidos: ["permiso_20", "permiso_33", "permiso_17", "permiso_15"],
	},
];

// 178DIGARU
// L3G4p3te6vea

// 180MABAME
// fS35pqJNBcWa
